/**
 * Given a numeric value, formats it as currency (e.g., 1234 becomes $1,234.00).
 * @param {number|undefined} value - The number to format as currency, or undefined if N/A.
 * @returns {string} The formatted value.
 */
const formatCurrency = (value) => (typeof value === 'number' && !Number.isNaN(value)
  ? new Intl.NumberFormat(
    'en-US',
    {
      currency: 'USD',
      style: 'currency',
    },
  ).format(value) : 'N/A');

export default formatCurrency;
